export const MY_PURCHASES = '/my-purchases'
